export default __webpack_public_path__ + "static/media/photo-inpainting-challenge.d5de845d.png";